module.exports = __webpack_public_path__ + "static/media/WIN4-NEW.e0ca97e8.apng";